<div class="header">
  <h1>Compatability Quiz</h1>
  <p>
    Ten extremely serious questions. Your answers will be processed in a veri scientif ai algorithm to determine your compatability. Your answers will be stored in a very secure location, and sold to the highest bidder.
  </p>
</div>

<form class="quiz" (ngSubmit)="submit()">
  @for (q of questions; track q.id) {
    <mat-card class="q-card">
      @switch (q.kind) {
        @case ("radio") {
          <div class="prompt">{{ q.prompt }}</div>
          <mat-radio-group
            class="stack"
            [name]="q.id"
            [ngModel]="answers[q.id]"
            (ngModelChange)="onAnswer(q.id, $event)"
          >
            @for (opt of q.options; track opt.value) {
              <mat-radio-button [value]="opt.value">{{ opt.label }}</mat-radio-button>
            }
          </mat-radio-group>
        }
        @case ("slider") {
          <div class="prompt">{{ q.prompt }}</div>
          <div class="slider-row">
            <mat-slider
              class="slider"
              [min]="q.min"
              [max]="q.max"
              [step]="q.step"
              discrete
              [showTickMarks]="q.showTicks === true"
            >
              <input
                matSliderThumb
                [name]="q.id + '-thumb'"
                [ngModel]="asNumber(answers[q.id])"
                (ngModelChange)="onAnswer(q.id, $event)"
              />
            </mat-slider>
            <span class="slider-value">{{ answers[q.id] }}</span>
          </div>
          <div class="slider-hints">
            <span>{{ q.hintLow }}</span>
            <span>{{ q.hintHigh }}</span>
          </div>
        }
        @case ("text") {
          <div class="prompt">{{ q.prompt }}</div>
          <mat-form-field class="full" appearance="outline">
            <mat-label>Your answer</mat-label>
            <textarea
              matInput
              [rows]="q.rows"
              [placeholder]="q.placeholder"
              [name]="q.id"
              [ngModel]="asString(answers[q.id])"
              (ngModelChange)="onAnswer(q.id, $event)"
            ></textarea>
          </mat-form-field>
        }
        @case ("select") {
          <div class="prompt">{{ q.prompt }}</div>
          <mat-form-field class="full" appearance="outline">
            <mat-label>Choose wisely</mat-label>
            <mat-select [name]="q.id" [ngModel]="answers[q.id]" (ngModelChange)="onAnswer(q.id, $event)">
              @for (opt of q.options; track opt.value) {
                <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
        @case ("toggleGroup") {
          <div class="prompt">{{ q.prompt }}</div>
          <mat-button-toggle-group
            class="toggle-wrap"
            [name]="q.id"
            [ngModel]="answers[q.id]"
            (ngModelChange)="onAnswer(q.id, $event)"
          >
            @for (opt of q.options; track opt.value) {
              <mat-button-toggle [value]="opt.value">{{ opt.label }}</mat-button-toggle>
            }
          </mat-button-toggle-group>
        }
        @case ("multi") {
          <div class="prompt">{{ q.prompt }}</div>
          <div class="multi">
            @for (opt of q.options; track opt.value) {
              <mat-checkbox
                [checked]="isMultiSelected(q.id, opt.value)"
                (change)="toggleMulti(q.id, opt.value, $event.checked)"
              >
                {{ opt.label }}
              </mat-checkbox>
            }
          </div>
        }
        @case ("toggle") {
          <div class="prompt">{{ q.prompt }}</div>
          <mat-slide-toggle
            [name]="q.id"
            [ngModel]="asBool(answers[q.id])"
            (ngModelChange)="onAnswer(q.id, $event)"
          >
            Yes, obviously
          </mat-slide-toggle>
        }
      }
    </mat-card>
  }

  <div class="submit-wrap">
    <button mat-raised-button color="primary" type="submit">
      <mat-icon aria-hidden="true">send</mat-icon>
      Submit compatibility intel
    </button>
  </div>
</form>
